"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataFeedMessageHeaderT = exports.DataFeedMessageHeader = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const data_feed_message_js_1 = require("../../solarxr-protocol/data-feed/data-feed-message.js");
class DataFeedMessageHeader {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsDataFeedMessageHeader(bb, obj) {
        return (obj || new DataFeedMessageHeader()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsDataFeedMessageHeader(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new DataFeedMessageHeader()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    messageType() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : data_feed_message_js_1.DataFeedMessage.NONE;
    }
    message(obj) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__union(obj, this.bb_pos + offset) : null;
    }
    static startDataFeedMessageHeader(builder) {
        builder.startObject(2);
    }
    static addMessageType(builder, messageType) {
        builder.addFieldInt8(0, messageType, data_feed_message_js_1.DataFeedMessage.NONE);
    }
    static addMessage(builder, messageOffset) {
        builder.addFieldOffset(1, messageOffset, 0);
    }
    static endDataFeedMessageHeader(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createDataFeedMessageHeader(builder, messageType, messageOffset) {
        DataFeedMessageHeader.startDataFeedMessageHeader(builder);
        DataFeedMessageHeader.addMessageType(builder, messageType);
        DataFeedMessageHeader.addMessage(builder, messageOffset);
        return DataFeedMessageHeader.endDataFeedMessageHeader(builder);
    }
    unpack() {
        return new DataFeedMessageHeaderT(this.messageType(), (() => {
            const temp = (0, data_feed_message_js_1.unionToDataFeedMessage)(this.messageType(), this.message.bind(this));
            if (temp === null) {
                return null;
            }
            return temp.unpack();
        })());
    }
    unpackTo(_o) {
        _o.messageType = this.messageType();
        _o.message = (() => {
            const temp = (0, data_feed_message_js_1.unionToDataFeedMessage)(this.messageType(), this.message.bind(this));
            if (temp === null) {
                return null;
            }
            return temp.unpack();
        })();
    }
}
exports.DataFeedMessageHeader = DataFeedMessageHeader;
class DataFeedMessageHeaderT {
    constructor(messageType = data_feed_message_js_1.DataFeedMessage.NONE, message = null) {
        this.messageType = messageType;
        this.message = message;
    }
    pack(builder) {
        const message = builder.createObjectOffset(this.message);
        return DataFeedMessageHeader.createDataFeedMessageHeader(builder, this.messageType, message);
    }
}
exports.DataFeedMessageHeaderT = DataFeedMessageHeaderT;
